export const ssRoles = [
  {
    id: 'practitioners_principals',
    label: 'Principals',
  },
  {
    id: 'practitioners_non_principals',
    label: 'Practitioners',
  },
  {
    id: 'coaches',
    label: 'Coaches',
  },
];

export interface MessageRoleDto {
  id: string;
  label: string;
}
